import React from 'react';
import { GridToolbarContainer, GridToolbarFilterButton, GridToolbarExport } from '@mui/x-data-grid';

function CustomToolbar(props) {
    return (
    <div className="d-flex align-items-center">
        <div className="ps-2 me-auto">
            <GridToolbarContainer>
                <GridToolbarFilterButton />
                <GridToolbarExport 
                    csvOptions={{
                        fileName: props.fileName,
                        utf8WithBom: true,
                    }}
                />
            </GridToolbarContainer>
        </div>
        <div className="pe-2">
            {/* <button>Hi</button> */}
        </div>
    </div>
    );
}

export default CustomToolbar;